// cover.js
var Cover = pc.createScript('cover');

Cover.prototype.initialize = function() {
    Cover.instance = this;
    this.cap1 = this.app.root.findByName('Hatch_Right');
    this.cap2 = this.app.root.findByName('Hatch_Left');
    this.animEnt = this.entity.anim;
    this.app.on('cover:stat',this.coverpos,this);
    this.entity.on("destroy", this.OnDestroy,this);
};

Cover.prototype.coverpos = function(status){
    if(status === true){
        SoundManager.instance.playSound('CoverOpen');
        this.cap1.tween(this.cap1.getLocalPosition()).to({x: 1.4, y: 0.098, z: 4.639},0.15,pc.Linear).start();
        this.cap2.tween(this.cap2.getLocalPosition()).to({x: -1.4, y: 0.098, z: 4.639},0.15,pc.Linear).start();
    }
    else{
        SoundManager.instance.playSound('CoverClose');
        this.cap1.tween(this.cap1.getLocalPosition()).to({x: 0.465, y: 0.098, z: 4.639},0.15,pc.Linear).start();
        this.cap2.tween(this.cap2.getLocalPosition()).to({x: -0.55, y: 0.098, z: 4.639},0.15,pc.Linear).start();
    }
};

Cover.prototype.closeCover = function() {
        this.cap1.tween(this.cap1.getLocalPosition()).to({x: 0.465, y: 0.098, z: 4.639},0.15,pc.Linear).start();
        this.cap2.tween(this.cap2.getLocalPosition()).to({x: -0.55, y: 0.098, z: 4.639},0.15,pc.Linear).start();
};

Cover.prototype.OnDestroy = function(){
    this.app.off('cover:stat',this.coverpos,this);
    this.entity.off("destroy", this.OnDestroy,this);
};

